import ko from 'knockout';
import _ from 'lodash';

export default class userObj {

    constructor(data) {

        console.log("userObj: constructor");
        console.log(data);
        this.componentname = "userObj";

        //userObj Object
        this.userid = ko.observable(data.userid);
        this.name = ko.observable(data.name);
        this.title = ko.observable(data.title);
        this.email = ko.observable(data.email);
        this.subid = ko.observable(data.subid);
        this.subparentid = ko.observable(data.subparentid);
        this.partnerid = ko.observable(data.partnerid);
        this.jdmuserroleid = ko.observable(data.jdmuserroleid);
        this.valid = ko.observable(data.valid);
        this.password = ko.observable(data.password);

    }

}

//export let  subTopicObj = new subTopicObjModel();


// WEBPACK FOOTER //
// ./src/objects/userObj.js